// Module
var code = " <svg fill=\"none\" stroke=\"currentColor\" width=\"100%\" height=\"100%\" viewBox=\"0 0 12 12\" xmlns=\"http://www.w3.org/2000/svg\"> <path stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"1.25\" d=\"M1 11L11 1M1 1l10 10\"/> </svg> ";
// Exports
module.exports = code;